


















import { Component, Vue } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import AddNewTicketForm from '@/components/User/Panels/AddNewTicketForm.vue';

@Component({
    components: {
        AddNewTicketForm,
    },
})
export default class CreateNewTicket extends Vue {
    constructor() {
        super();
    }

    public close() {
        this.$store.commit(Mutations.SET_TICKET_CREATE_FORM_OVERLAY_VISIBILITY, false);
    }
}
